import PreparatoryStandardsPage from './_PreparatoryStandardsPage'

export default function FinisherDFSettingsPage() {
  return <PreparatoryStandardsPage kind="finisher-df" />
}
